import { createSlice } from "@reduxjs/toolkit";

const BROKER_CLOSING_REASONS_SLICE_NAME = "lenderCallLogBrokerClosingReasons";

const initialState = {
  brokerClosingReasons: [],
};

const brokerClosingReasonsSlice = createSlice({
  name: BROKER_CLOSING_REASONS_SLICE_NAME,
  initialState,
  reducers: {
    populateBrokerClosingReasons(state, action) {
      state.brokerClosingReasons = action.payload;
    },
  },
});

export const { populateBrokerClosingReasons } = brokerClosingReasonsSlice.actions;

export default brokerClosingReasonsSlice.reducer;
